<template>
  <v-card tile elevation="0">
    <v-card-title v-if="service" class="pb-0 pt-0">
      {{ service }}

      <v-spacer></v-spacer>
    </v-card-title>

    <v-card-text v-if="is_show_percentbar">
      <span class="text-subtitle-1">
        {{ `${usage} / ${limit} (${safePercentage}%已使用)` }}
      </span>
      <v-progress-linear
        :value="safePercentage"
        :color="color"
        height="10"
        :style="{
          width: '100%',
          borderRadius: '3px',
        }"
      >
      </v-progress-linear>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'UsedQuotaInfo',
  props: {
    service: String,
    usage: Number,
    limit: Number,
    is_show_percentbar: Boolean,
    is_show_subscription_btn: Boolean,
  },
  data() {
    return {
      percentage: null,
      color: 'primary',
      // usedPercent: null
    }
  },
  computed: {
    safePercentage() {
      if (this.limit === 0) return 100
      const percent = (this.usage / this.limit) * 100
      return isFinite(percent) ? Math.round(percent) : 100
    },
  },
  mounted() {
    console.log('配額component_usage', this.usage)
    console.log('配額component_limit', this.limit)
    this.percentage = Math.round((this.usage / this.limit) * 100)
    console.log('percentage', this.percentage)

    if (!isFinite(this.percentage)) {
      if (this.percentage >= 70) {
        this.color = 'amber'
      }

      if (this.percentage >= 90) {
        this.color = 'pink'
      }

      if (isNaN(this.percentage)) {
        this.color = 'pink'
      }
    } else {
      if (this.percentage === 0) {
        if (this.limit === 0) {
          this.color = 'pink'
        } else {
          this.color = 'primary'
        }
      } else {
        this.color = 'pink'
      }
    }

    console.log('colorcolor', this.color)
  },
}
</script>

<style scoped></style>
